import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './HiringPopup.css';

const HiringPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show popup only on home page `/`
    if (location.pathname === '/') {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [location]);

  const handleClose = () => setShowPopup(false);

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="close-btn" onClick={handleClose}>×</button>
        <img
          src="/images/pic.jpeg"
          alt="We Are Hiring"
          className="popup-image"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default HiringPopup;
